export const STORAGE_NAME = 'store';
export const FILE_STORAGE_NAME = 'store';
export const LOGS_NAME = 'logs';
export const DB_NAME = 'glueple-redux';
export const SAVE_TIME_DELAY = 5000;
